"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campoformido": {
    "138398ed": [{
      "hkey": "698011a6",
      "slug": "basaldella-villa-primavera",
      "name": "Basaldella-Villa Primavera",
      "primary": true,
      "skipSearch": false
    }],
    "basaldella": [{
      "hkey": "698011a6",
      "slug": "basaldella-villa-primavera",
      "name": "Basaldella-Villa Primavera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "efdd2260": [{
      "hkey": "698011a6",
      "slug": "basaldella-villa-primavera",
      "name": "Basaldella-Villa Primavera",
      "primary": true,
      "skipSearch": false
    }],
    "villa-primavera": [{
      "hkey": "698011a6",
      "slug": "basaldella-villa-primavera",
      "name": "Basaldella-Villa Primavera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campoformido"
    }]
  }
};
exports["default"] = _default;